import { render, staticRenderFns } from "./ModalInformations.vue?vue&type=template&id=1c9b2412&scoped=true&"
import script from "./ModalInformations.vue?vue&type=script&lang=js&"
export * from "./ModalInformations.vue?vue&type=script&lang=js&"
import style0 from "./ModalInformations.vue?vue&type=style&index=0&id=1c9b2412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9b2412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VLayout})
